export const BLUR_TIMEOUT = 200;

export default {
  BLUR_TIMEOUT
};
